export default __webpack_public_path__ + "static/media/landscaping1.88106e18.jpeg";